import index from './index.js';
import user from './user.js';
import attestation from './attestation.js';

export default {
    index,
    user,
    attestation
}
